import { navItems, siteInfo, topicCategories } from '@/mocks/home';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-water-flash-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-base font-bold text-background-50">17.cc 吃瓜攻略指南</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-200">
              {siteInfo.slogan}。用系统化的攻略与教程，帮你把每一次围观都看得更明白。
            </p>
            <a
              href={`mailto:${siteInfo.email}`}
              className="mt-4 inline-flex items-center gap-2 whitespace-nowrap font-label text-sm text-background-100 transition-colors hover:text-primary-300"
            >
              <i className="ri-mail-line text-base" aria-hidden="true"></i>
              {siteInfo.email}
            </a>
          </div>

          <nav aria-label="页脚导航">
            <h3 className="font-heading text-sm font-bold text-background-50">攻略导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navItems.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="inline-flex items-center gap-1.5 font-label text-sm text-background-200 transition-colors hover:text-background-50"
                  >
                    <i className="ri-arrow-right-s-line text-base text-primary-300" aria-hidden="true"></i>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">热门分类</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {topicCategories.map((category) => (
                <li key={category.key}>
                  <a
                    href="#topics"
                    className="inline-flex items-center gap-1.5 font-label text-sm text-background-200 transition-colors hover:text-background-50"
                  >
                    <i className="ri-hashtag text-base text-secondary-400" aria-hidden="true"></i>
                    {category.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">快速开始</h3>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              第一次来？建议从「吃瓜入门」开始，再跟着「四步攻略」跑通一次完整流程。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <a
                href="#intro"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 font-label text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-book-open-line text-sm" aria-hidden="true"></i>
                吃瓜入门
              </a>
              <a
                href="#steps"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-100/30 px-3.5 py-2 font-label text-xs font-medium text-background-100 transition-colors hover:bg-background-100/10"
              >
                <i className="ri-route-line text-sm" aria-hidden="true"></i>
                四步攻略
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/15">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 px-4 py-6 md:flex-row md:items-center md:justify-between md:px-8">
          <p className="font-label text-xs text-background-300">
            © {year} 17.cc 吃瓜攻略指南 · 本站为攻略与教程内容站，仅供学习参考
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1.5 font-label text-xs text-background-300">
            <a href="#top" className="transition-colors hover:text-background-50">
              回到顶部
            </a>
            <a href="#faq" className="transition-colors hover:text-background-50">
              常见问题
            </a>
            <a href="#about" className="transition-colors hover:text-background-50">
              联系我们
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}